import EmployeeWorkInWorkInLocationComponents from "../components/EmployeeWorkInWorkInLocation";
import useEmployeeWorkInWorkInLocation from "../hooks/useEmployeeWorkInWorkInLocation";

function EmployeeWorkInWorkInLocation() {
  const employeeWorkInWorkInLocationProps = useEmployeeWorkInWorkInLocation();
  return (
    <EmployeeWorkInWorkInLocationComponents
      {...employeeWorkInWorkInLocationProps}
    />
  );
}

export default EmployeeWorkInWorkInLocation;
